import React from 'react';
import Tooltip from '../../controls/tooltip.js';
import HeaderBackButton from '../../controls/headerBackButton.js';
import CloseButton from '../../controls/closeButton.js';
import HelpButton from '../../controls/helpButton.js';
import { dataHooks } from './constants';
import TooltipOnEllipsis from '../../controls/tooltipOnEllipsis';
export default function () {
  var _this$props = this.props,
      automationId = _this$props.automationId,
      dataHook = _this$props.dataHook,
      shouldTranslate = _this$props.shouldTranslate,
      onMouseDown = _this$props.onMouseDown,
      onBack = _this$props.onBack,
      onHelp = _this$props.onHelp,
      onClose = _this$props.onClose,
      noCloseBtn = _this$props.noCloseBtn,
      noHelpBtn = _this$props.noHelpBtn,
      style = _this$props.style,
      closeSymbol = _this$props.closeSymbol,
      helpSymbol = _this$props.helpSymbol,
      backTooltipContent = _this$props.backTooltipContent,
      backAutomationId = _this$props.backAutomationId,
      children = _this$props.children,
      actionsBar = _this$props.actionsBar;
  return /*#__PURE__*/React.createElement("header", {
    "data-aid": automationId,
    "data-hook": dataHook,
    onMouseDown: onMouseDown,
    className: this.getClassName(),
    style: style
  }, onBack ? /*#__PURE__*/React.createElement(Tooltip, {
    key: "backBtnTooltip",
    disabled: !backTooltipContent,
    content: backTooltipContent,
    shouldTranslate: shouldTranslate
  }, /*#__PURE__*/React.createElement(HeaderBackButton, {
    key: "backBtn",
    automationId: backAutomationId,
    onClick: onBack,
    dataHook: "".concat(dataHook, "-back-button")
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: "panel-header-title"
  }, /*#__PURE__*/React.createElement(TooltipOnEllipsis, {
    dataHook: dataHooks.panelHeaderTitle
  }, children)), actionsBar, noHelpBtn ? null : /*#__PURE__*/React.createElement(HelpButton, {
    onClick: onHelp,
    dataHook: "".concat(dataHook, "-help-button"),
    key: "helpBtn",
    symbol: helpSymbol
  }), noCloseBtn ? null : /*#__PURE__*/React.createElement(CloseButton, {
    onClick: onClose,
    dataHook: "".concat(dataHook, "-close-button"),
    key: "closeButton",
    symbol: closeSymbol
  }));
}